import { combineActions, handleActions } from 'redux-actions'

import { setIsAnswerInProgress, sendFormAnswer, resetFormsState } from '../actions'

const defaultState = false

export default handleActions<boolean, any>(
  {
    [setIsAnswerInProgress.toString()](state, action: ReturnType<typeof setIsAnswerInProgress>) {
      return action.payload
    },
    [sendFormAnswer.request.toString()](state, action) {
      return true
    },
    [combineActions(sendFormAnswer.success, sendFormAnswer.failed).toString()](state, action) {
      return false
    },
    [resetFormsState.toString()](state, action) {
      return defaultState
    },
  },
  defaultState
)
